__webpack_require__.p = "https://omega-code-gen.netlify.app/";